import React from 'react'

const Schemes = () => {
  return (
    <div>Schemes</div>
  )
}

export default Schemes